import { QueryKey, useQuery } from '@tanstack/react-query'
import {
  getShiftWorkBreaks,
  ShiftWorkBreak,
} from 'api/shifts/getShiftWorkBreaks'
import { AxiosError } from 'axios'
import { shiftWorkBreaksKey } from './keys'

export const useShiftWorkBreaksQuery = ({
  shiftId,
  workId,
}: {
  shiftId: number
  workId: number
}) => {
  return useQuery<ShiftWorkBreak[], AxiosError, ShiftWorkBreak[], QueryKey>({
    queryKey: shiftWorkBreaksKey(shiftId, workId),
    queryFn: () => getShiftWorkBreaks(workId),
  })
}
